<style scoped lang="less">
@import url('../../assets/less/base.less');
    .data-overview {
        width: 100%;
        .total-data-list {
            width: 100%;
            display: flex;
            justify-content: space-between;
            li {
                position: relative;
                width: 20%;
                color: @default-commonGray;
                padding: 2%;
                overflow: hidden;
                border: 1px solid #e5e5e5;
                &.total-data-item5 {
                    width: 19%;
                }
                &.total-data-item4 {
                    width: 24%;
                    padding: 2%;
                }
                &.total-data-item3 {
                    width: 32.2%;
                    padding: 20px 2%;
                }
                .data-title {
                    height: 14px;
                    line-height: 14px;
                    padding-bottom: 20px;
                    margin-bottom: 2%;
                }
                .data-num {
                    color: #4a7ae6;
                    font-size: 24px;
                    &.recolor {
                        color: #000;
                        font-weight: 400;
                    }
                }
                >img {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 16%;
                    height: auto;
                    max-width: 55px;
                    max-height: 60%;
                }
            }
        }
    }
</style>

<template>
    <div class="fixed-margin-top data-overview">
        <ul class="total-data-list">
            <li v-for="(item, index) in resData.data" :class="`total-data-item${resData.data.length}`" :key="index">
                <p class="data-title">{{item['text']}}</p>
                <span :class="pageMsg=='index' ? 'data-num recolor': 'data-num'">{{item['amount']}}</span>
                <span>{{item['unit']}}</span>
                <img class="data-icon" :src="require(`../../assets/images/data-icon-${index+1}.png`)" v-if="pageMsg=='index'"/>
            </li>
        </ul>
        <line-chart :line="resData.list"></line-chart>
    </div>
</template>

<script>
import lineChart from "../../components/chart.vue"
import {axiosGet} from "../../axios/axios"

export default{
  components:{
    lineChart
  },
  props:{
    ajaxUrl: {
      default: ''
    },
    pageMsg: '',   //判断是哪个页面
    lineParams: {
      default: ''
    }
  },
  data(){
    return {
        resData: {
            data: [],
            list: {},
            text: {}
        },
    };
  },
  watch: {
      ajaxUrl: function(newQuestion, oldQuestion){
          //重新请求数据，渲染图图表
          //this.getOverviewData();
      },
      lineParams: function(){
          this.getOverviewData();
      }
  },
  methods:{
    getOverviewData: function(){
      let result = axiosGet(this.ajaxUrl,this.lineParams);
      result.then((response) => {
        if (response.data.error_code == 0) {
            this.resData = response.data;
            //向父级组件传递最新通知
            this.sendMsgToParent();
         }
      })
    },
    sendMsgToParent:function(){
       if (this.resData.notice && this.resData.notice instanceof Array) {
         let newNotice = this.resData['notice'][0];
         this.$emit("listenToChild", newNotice);
       }
    },
  },
  created(){
    if (this.pageMsg == 'index') {
      //首页的url不会变化，需要手动调用函数
      this.getOverviewData();
    }
  },
  mounted(){
  }
}

</script>



// WEBPACK FOOTER //
// src/containers/dataOverview/dataOverview.vue